import React from 'react';

export default function FwCreditCard({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-credit-card' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
